export const eWebsiteTypes = Object.freeze({
  KUICK: "Kuick",
  DINEORDER: "Dineorder",
});

export const eWebsiteColors = Object.freeze({
  DINEORDER: "#e84d0a",
  KUICK: "#FF0A38",
});